import { render, staticRenderFns } from "./Mapped.vue?vue&type=template&id=515c1631&scoped=true&"
import script from "./Mapped.vue?vue&type=script&lang=js&"
export * from "./Mapped.vue?vue&type=script&lang=js&"
import style0 from "./Mapped.vue?vue&type=style&index=0&id=515c1631&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c1631",
  null
  
)

export default component.exports